var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-row',{staticClass:"centered-column-layout"},[_c('a-col',{attrs:{"xs":{span: 24, offset: 0},"lg":{span: 20, offset: 2},"xl":{span: 16, offset: 4}}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }